import { Avatar, Button, Grid } from "antd";
import { useTranslation } from "react-i18next";
import EmptyCoach from "../../../../assets/images/content/empty_coach.png";
import Certificate from "../../../../assets/images/icons/Certificate";
import MapPinFilled from "../../../../assets/images/icons/MapPinFilled";
import Ski from "../../../../assets/images/icons/Ski";
import { H3, H6 } from "../../../../components/NormalFonts";
import {
  CoachInfoResponse,
  DataMappingType,
} from "../../../../hooks/Coach/data";
import { assign } from "../../enumerations/assign";
import styles from "./styleModule";

const PictureContainer = ({
  coachInfo,
  handleClickBook,
}: {
  coachInfo: CoachInfoResponse;
  handleClickBook: () => void;
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const PROFILE_ITEMS: DataMappingType[] = [
    {
      key: "ski_resort_codes",
      icon: (
        <MapPinFilled
          style={{
            fontSize: screens.md ? 28 : 20,
            color: "#06304D",
            minWidth: screens.md ? 28 : 20,
            minHeight: screens.md ? 28 : 20,
          }}
        />
      ),
      render: (record: CoachInfoResponse) => {
        return record.ski_resort_codes.length <= 0 ? (
          <H6
            className={styles.contentDesc}
            weight="normal"
            color="var(--primary-90)"
          >
            {t("normal.empty")}
          </H6>
        ) : (
          <H6
            className={styles.contentDesc}
            weight="normal"
            color="var(--primary-90)"
          >
            {record.ski_resort_codes
              .map((code: string) => {
                return t(`skiresort.${code}`);
              })
              .join(" / ")}
          </H6>
        );
      },
    },
    {
      key: "skill_codes",
      icon: (
        <Ski
          style={{
            fontSize: screens.md ? 28 : 20,
            color: "#06304D",
            minWidth: screens.md ? 28 : 20,
            minHeight: screens.md ? 28 : 20,
          }}
        />
      ),
      render: (record: CoachInfoResponse) => {
        return record.skill_codes.length <= 0 ? (
          <H6
            className={styles.contentDesc}
            weight="normal"
            color="var(--primary-90)"
          >
            {t("normal.empty")}
          </H6>
        ) : (
          <H6
            className={styles.contentDesc}
            weight="normal"
            color="var(--primary-90)"
          >
            {record.skill_codes
              .map((skill: string) => t(`normal.skill.${skill}`))
              .join(" / ")}
          </H6>
        );
      },
    },
    {
      key: "certificate_name",
      hidden: !coachInfo?.certificate_name,
      icon: (
        <Certificate
          style={{
            fontSize: screens.md ? 28 : 20,
            color: "var(--primary-90)",
            minWidth: screens.md ? 28 : 20,
            minHeight: screens.md ? 28 : 20,
          }}
        />
      ),
      render: (record: CoachInfoResponse) => {
        return (
          <H6
            className={styles.contentDesc}
            weight="normal"
            color={record.certificate_color || "var(--primary-90)"}
          >
            {record?.certificate_name}
          </H6>
        );
      },
    },
  ];

  const renderItem = (
    _item: DataMappingType,
    profile: CoachInfoResponse | undefined
  ) => {
    if (!profile) return;
    if (_item.render) return _item.render(profile);
    return profile[_item.key as keyof CoachInfoResponse] as React.ReactNode;
  };

  return (
    <div
      className={`${styles.pictureContainer} ${
        screens.md ? "" : styles.mobile
      }`}
    >
      <div className={styles.bioContainer}>
        <Avatar
          size={screens.md ? 204 : 124}
          style={{
            minWidth: screens.md ? 204 : 124,
            minHeight: screens.md ? 204 : 124,
          }}
          className={`${styles.avatar} ${screens.xl ? "" : styles.small}`}
          shape={"square"}
          src={coachInfo?.profile_url}
          icon={
            <Avatar
              size={screens.md ? 204 : 124}
              className={`${styles.avatar} ${screens.xl ? "" : styles.small}`}
              shape={"square"}
              src={EmptyCoach}
            />
          }
        />
        <H3 weight="heavy" color="var(--primary)" className={styles.pcTitle}>
          {coachInfo?.nickname}
        </H3>
        {coachInfo?.can_assign === assign.ALLOW && (
          <Button
            className={styles.pcButton}
            size="middle"
            style={{
              background: "var(--primary)",
              color: "var(--Neutral-light-10)",
            }}
            variant="solid"
            onClick={handleClickBook}
          >
            {t("preview.book")}
          </Button>
        )}
      </div>
      <div className={styles.profiles}>
        {PROFILE_ITEMS.map((_profile: DataMappingType) => {
          if (_profile.hidden) return null;
          return (
            <div key={_profile.key}>
              <div className={styles.profileItem}>
                {_profile.icon}
                {renderItem(_profile, coachInfo)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PictureContainer;
